import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
import DeleteIcon from '../../assets/svgs/DeleteReportIcon';
import { v4 as uuidV4 } from 'uuid';
import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import Button from '../../components/Button/Button'
import { Link } from 'react-router-dom';
import ArrowIcon from '../../assets/svgs/ArrowIcon';

import { AddInstitutionStyle } from './AddInstitutionStyle';

import PageWithMenu from '../../components/PageWithMenu/PageWithMenu';
import AddInstitutionForm from '../../components/AddInstitutionForm/AddInstitutionForm';
import Header from '../../components/Header/Header';
import Loading from '../../components/Loading/Loading';
import SnackBar from '../../components/SnackBar/SnackBar';
import { useSelector } from 'react-redux';

import { breakpoints } from '../../ui/variables';
import { useBreakpoint } from '../../utils/useBreakpoint';
import { headerVariables } from '../../components/Header/HeaderStyle';

import PlusIcon from '../../assets/svgs/PlusIcon';
import NegativeIcon from '../../assets/svgs/NegativeIcon';

const AddInstitution = () => {
  const language = useSelector((state) => state.settings.language);
  const breakpoint = useBreakpoint();

  const [showMenu, setShowMenu] = useState(false);
  const [pageWithMenuStyle] = useState({
    paddingTop: `${headerVariables.main.height.iphone + 52}px`,
  });

  const [institutions, setInstitutions] = useState([uuidV4()]);
  const [loading, setLoading] = useState(false);
  const [actionComplete, setActionComplete] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [headquarterOptions, setHeadquarterOptions] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setActionComplete(null);
    }, 3000);
    return () => clearTimeout(timer);
  }, [actionComplete]);

  useEffect(() => {
    const headquarterOptionsArray = [
      { key: 0, value: '', text: translate('selectHeadquarters', language) },
    ];

    setLoading(true);
    Api.getAllHeadQuarterList()
      .then((response) => {
        const institutionList = response.result;
        institutionList.forEach((institution, institutionIndex) => {
          const institutionItem = {
            key: institutionIndex + 1,
            value: institution.id,
            text: institution.name,
          };

          headquarterOptionsArray.push(institutionItem);
        });

        setHeadquarterOptions(headquarterOptionsArray);
      })
      .finally(() => setLoading(false));
  }, [language]);

  useEffect(() => {
    const userOptionsArray = [
      { key: 0, value: '', text: translate('selectAdministrator', language) },
    ];

    setLoading(true);
    Api.getResponsibleThatAreNotAdminUser()
      .then((response) => {
        const userList = response.data;
        userList.forEach((user, userIndex) => {
          const userItem = {
            key: userIndex + 1,
            value: user.id,
            text: user.name,
          };

          userOptionsArray.push(userItem);
        });

        setUserOptions(userOptionsArray);
      })
      .finally(() => setLoading(false));
  }, [language]);

  useEffect(() => {
    if (!loading) {
      const timeout = setTimeout(() => {
        setActionComplete(null);
      }, 3500);

      return () => clearTimeout(timeout);
    }

    return null;
  }, [loading]);

  const handleAddNewInstitutionForm = (event) => {
    event.preventDefault();

    const newInstitution = [...institutions];
    newInstitution.push(uuidV4());
    setInstitutions(newInstitution);
    // const formIndex = newInstitution.indexOf(formKey);
    // newInstitution.splice(formIndex, 1);
    // setInstitutions(newInstitution);
  };

  const removeAddedNewInstitutionForm = (key) => {
    const currentInstitutions = institutions.filter((i) => i !== key);

    setInstitutions(currentInstitutions?.length ? currentInstitutions : []);
  };

  const handleShowMenu = () => setShowMenu(!showMenu);

  const remove_last_institution = () => {
    let valor = institutions.splice(institutions['length'] - 1 ,1)
    setInstitutions(institutions.filter(item => item != valor[0]))
  }

  return (
    <PageWithMenu showMenu={showMenu} menuStyle={pageWithMenuStyle}>
      <AddInstitutionStyle>
        <Header
          handleShowMenu={
            breakpoint.width < breakpoints.ipadLandscape.width
              ? handleShowMenu
              : null
          }
        />
        <div className="back-button-container">
          <Link to="/instituicoes" className="back-link">
            <span className="icon">
              <ArrowIcon />
            </span>
            {translate('back', language)}
          </Link>
        </div>
        {actionComplete?.type ? (
          <div className="snack-bar-wrapper">
            <SnackBar type={actionComplete.type} text={actionComplete.text} />
          </div>
        ) : null}

        <div className="header-institution-registration">
          <span className="title-header">
            <span className="title">{translate('institutionRegistration', language)}</span>
            <span className="number-of-registers">
              <span className="score">{translate('adding', language)}:</span>{' '}
              {institutions?.length ? institutions?.length : 0} {institutions?.length > 1 ? translate('institutions', language) : translate('institution', language)}
            </span>
          </span>
        </div>

        {institutions.map((key, index) => {
          return (
              <AddInstitutionForm
              key={key}
              index={index}
              setLoading={setLoading}
              setActionComplete={setActionComplete}
              userOptions={userOptions}
              setUserOptions={setUserOptions}
              headquarterOptions={headquarterOptions}
              removeAddedNewInstitutionForm={() =>
                removeAddedNewInstitutionForm(key)
              }
            />
          );
        })}
          {institutions['length'] > 1 ? 
            <a
              type="button"
              className="add-new-institution"
              onClick={remove_last_institution}
              style={{'color':'red'}}
              >
              <span className="plus-container" style={{'border':'2px solid red'}}>
                <NegativeIcon />
              </span>{' '}
              <span className="text" style={{'color':'red'}}>Remove institution</span>
            </a>:
            ''
            }
        <button
          type="button"
          className="add-new-institution"
          onClick={handleAddNewInstitutionForm}
        >
          <span className="plus-container">
            <PlusIcon />
          </span>{' '}
          <span className="text">Add new institution</span>
        </button>
        {/* 
        <AddUserForm
          isOpenAddUserForm={isOpenAddUserForm}
          setIsOpenAddUserForm={setIsOpenAddUserForm}
          setUserActionComplete={setActionComplete}
          setLoading={setLoading}
        /> */}

        {loading ? <Loading /> : null}
      </AddInstitutionStyle>
    </PageWithMenu>
  );
};

export default AddInstitution;
